export const CircleIcon = ({ className }: { className: string }) => {
  return (
    <svg className={className} fill="none" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" fill="#FF0ECA" r="50" />
      <path d="M6.6 52.5 A43.5 43.5 0 1 1 93.4 52.5 Z" fill="#810693" />
    </svg>
  );
};
